module.exports = "<div class=\"$onionSkin fadable onion-skin\"></div>\n<div class=\"$actor actor\">\n  <img src=\"img/circle.png\">\n</div>\n"